'use client'

import {
	CONTEXTUAL_MESSAGE_TYPE,
	ContextualMessage,
} from '@fukku/contextual-message/ContextualMessage'
import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { GenericEvents } from 'product/types/GenericEvents'
import { ProductDisclaimer } from 'product/types/Product'
import { type ReactNode, useEffect, useMemo } from 'react'

import styles from './DisclaimerMessage.module.css'

const sizeDisclaimerKey: Record<ProductDisclaimer, string> = {
	[ProductDisclaimer.UpDisclaimer]:
		'product.sizeSelector.smallSizing.helpmessage',
	[ProductDisclaimer.DownDisclaimer]:
		'product.sizeSelector.bigSizing.helpmessage',
	[ProductDisclaimer.SizeguideDisclaimer]:
		'product.sizeSelector.helpSize.sizeguide.text',
	[ProductDisclaimer.MaternityDisclaimer]:
		'product.sizeSelector.helpSize.maternity.text',
}

export function DisclaimerMessage({
	type,
}: {
	readonly type: ProductDisclaimer
}): ReactNode {
	const { t } = useLabels()
	const key = useMemo(() => sizeDisclaimerKey[type], [type])

	useEffect(() => {
		sendGenericEvent(GenericEvents.SHOW_DISCLAIMER_SIZE)
	}, [])

	return (
		<ContextualMessage
			className={styles.sheetDisclaimer}
			type={CONTEXTUAL_MESSAGE_TYPE.INFO}
			message={t(key)}
		/>
	)
}
